import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { UsdPriceFragment } from "@/components/price/UsdPrice.fragment"

export const MintCTAModuleFragment = graphql(
  `
    fragment MintCTAModule on Drop {
      __typename
      stages {
        startTime
        maxTotalMintableByWallet
        eligibleMaxTotalMintableByWallet
        label
        stageIndex
        price {
          ...TokenPrice
          ...UsdPrice
        }
        eligiblePrice {
          ...TokenPrice
          ...UsdPrice
        }
      }
    }
  `,
  [TokenPriceFragment, UsdPriceFragment],
)
